import {ACCESS_TOKEN, COMPANY_ID, USER_ID} from '@constants/auth.constant'
import {LocalStorageService} from '@services/utils/localStorage.service'
import axios from 'axios'
import {ENV} from './ENV.config'

const instance = axios.create({
  baseURL: ENV.apiEndpoint,
  headers: {
    Accept: 'application/json',
  },
})

instance.interceptors.request.use(
  (config: any) => {
    const accessToken = LocalStorageService.get(ACCESS_TOKEN) || null
    const uid = LocalStorageService.get(USER_ID) || null
    const cid = LocalStorageService.get(COMPANY_ID) || null

    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`
    if (uid) config.headers.uid = uid
    if (cid) config.headers.cid = cid

    return config
  },
  (error) => {
    if (error.response) {
      return Promise.reject({
        ...error.response.data,
        ...{code: error.response.data.code || error.status},
      })
    }

    return Promise.reject({
      body: false,
      code: 404,
      msg: 'Server not responding',
    })
  }
)

instance.interceptors.response.use(
  (res: any) => {
    // A binary endpoint (the purchase-order letter) returns raw bytes, deliberately NOT wrapped in
    // an AppResponse envelope -- an envelope around a PDF is a corrupt PDF. So there is no `code`
    // to inspect: `res.data.code` is undefined on a Blob, which would fall through to the reject
    // below and fail EVERY successful download with an empty message. Hand it back untouched and
    // let the caller check the content type.
    if (res?.data instanceof Blob) return res

    if (res.data.code === 200) return {...res.data}

    if (res.data.code === 401) {
      LocalStorageService.clear()
      window.location.reload()
    }
    return Promise.reject({
      body: res.data.body,
      code: res.data.code,
      msg: res.data.msg,
    })
  },
  (error) => {
    if (error?.response) {
      if (error?.response?.data?.code === 401) {
        LocalStorageService.clear()
        window.location.reload()
      }

      // A refusal from a service's ACL or role gate is a real HTTP 403 whose sentence is in
      // `message` (core PermissionInterceptor, each service's AuthzInterceptor). Every caller toasts
      // `msg`, and axios 0.26 has no `error.status`, so without this a refusal reached the screen
      // with no code and an empty toast.
      if (error.response.status === 403) {
        const data = error.response.data || {}
        return Promise.reject({
          code: 403,
          msg: data.message || data.msg || 'You do not have permission to do this.',
          body: {},
        })
      }

      if (error?.response?.data?.error) {
        return Promise.reject({
          code: error?.response?.data?.code,
          msg: error?.response?.data?.error,
          body: {},
        })
      }

      return Promise.reject({
        ...error?.response?.data,
        ...{code: error.response.data.code || error.status},
      })
    } else {
      return Promise.reject({
        code: 500,
        msg: 'Server not responding',
        body: {},
      })
    }
  }
)

// const refreshToken = () => {
//   return instance.post("/auth/refresh-token");
// };
// const setToken = (accessToken: string) => {
//   LocalStorageService.set("accessToken", accessToken);
// };
// const setRefreshToken = (refreshToken: string) => {
//   LocalStorageService.set("refreshToken", refreshToken);
// };

export const axiosIns = instance
